import DOMPurify, { Config } from "dompurify";

const SANITIZE_CONFIG: Config = {
    ALLOWED_TAGS: ["b", "strong", "u", "a", "p", "br", "span"],
    ALLOWED_ATTR: ["href", "target", "rel"],
    ALLOW_DATA_ATTR: false,
};

export const getSanitizedHtml = (html: string): string =>
    DOMPurify.sanitize(html, SANITIZE_CONFIG) as string;
